import { createFileRoute, redirect } from '@tanstack/react-router'
import { editOrganizationSearch } from 'routes/organization/-searchParams'
import { Route as NewRoute } from 'routes/organization/index'
import { z } from 'zod'

const deprecatedOrganizationSearchParams = z.object({
  mode: z.literal('edit'),
})

export const Route = createFileRoute(
  '/organization/(deprecated_routes)/$orgID'
)({
  validateSearch: deprecatedOrganizationSearchParams,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: editOrganizationSearch(params.orgID),
      replace: true,
    })
  },
})
